"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParticipantState = void 0;
var ParticipantState;
(function (ParticipantState) {
    ParticipantState["Processed"] = "processed";
    ParticipantState["Error"] = "error";
    ParticipantState["SentToGenerator"] = "sent-to-generator";
    ParticipantState["Processing"] = "processing";
    ParticipantState["ReadyToGenerateClip"] = "ready-to-generate-clip";
    ParticipantState["New"] = "new";
})(ParticipantState = exports.ParticipantState || (exports.ParticipantState = {}));
//# sourceMappingURL=participant-state.js.map